import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode } from "vue"

import { ref } from "vue";
import AuthImage from "@/components/AuthImage.vue";
import { isMobile } from "@/core/config/WindowConfig";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserAvatar',
  props: {
  avatar: { type: String },
  name: { type: String, required: true },
  size: { type: String, default: "40px" },
  side: { type: String, default: "tenant" },
  rounded: { type: Boolean, default: false },
},
  setup(__props) {

const props = __props;


const src = ref("");
const avatarLetter = ref("");
const avatarClass = ref("symbol-" + props.size);
const letterAvatarColor = ref("");
// [
//   "bg-light-primary",
//   "bg-light-danger",
//   "bg-light-success",
//   "bg-light-warning",
//   "bg-light-info",
//   "bg-light-dark",
// ];

const processImageUrl = (url: string) => {
  let img_src = "";
  if (url == "no-image") {
    img_src = "/images/no-image.png";
  } else if (url == "no-avatar" || url == "") {
    img_src = "";
    let tname = props.name;
    if (tname == undefined || tname == "") {
      tname = "No Name";
    }

    avatarLetter.value = tname.charAt(0).toUpperCase();
    if (["A", "B", "C", "D", "E"].includes(avatarLetter.value)) {
      letterAvatarColor.value = "text-primary";
    } else if (["F", "G", "H", "I", "J"].includes(avatarLetter.value)) {
      letterAvatarColor.value = "text-danger";
    } else if (["K", "L", "M", "N", "O"].includes(avatarLetter.value)) {
      letterAvatarColor.value = "text-success";
    } else if (["P", "Q", "R", "S", "T"].includes(avatarLetter.value)) {
      letterAvatarColor.value = "text-warning";
    } else if (["U", "V", "W", "X", "Y"].includes(avatarLetter.value)) {
      letterAvatarColor.value = "text-info";
    } else {
      letterAvatarColor.value = "text-dark";
    }
  } else {
    // img_src =
    //   process.env.VUE_APP_API_URL +
    //   "/api/v1/client/media/" +
    //   url +
    //   "?access_token=" +
    //   JwtService.getToken();
    img_src = url;
  }
  return img_src;
};

src.value = processImageUrl(props.avatar);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
      'rounded-circle overflow-hidden': __props.rounded,
    }),
    style: _normalizeStyle({
      width: __props.size,
      height: __props.size,
    })
  }, [
    (src.value !== '')
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["symbol avatar-bg", avatarClass.value])
        }, [
          _createVNode(AuthImage, {
            imageGuid: __props.avatar,
            side: __props.side,
            size: __props.size
          }, null, 8, ["imageGuid", "side", "size"])
        ], 2))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["symbol", avatarClass.value])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["symbol-label fs-3 bg-light-danger", { letterAvatarColor: true }]),
            style: _normalizeStyle({
          width: __props.size + '!important',
          height: __props.size + '!important',
        })
          }, _toDisplayString(avatarLetter.value), 5)
        ], 2))
  ], 6))
}
}

})